var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page flex-col"},[_c('img',{staticClass:"image_4",attrs:{"referrerpolicy":"no-referrer","src":require("./assets/img/SketchPngda42bf625197ddbb0318b92615e29113bcab76c20772e08a14070f1133f90ea1.png")}})])
}]

export { render, staticRenderFns }